/* eslint-disable camelcase */
import _ from 'lodash';
import { PixKeyType } from '../constants/banking';
import { Card } from '../models';
import formatters from './formatters';

type ByPixArgs = {
    paymentMethod: 'pix';
};

type ByCardArgs = {
    cardId: Card['id'];
    cvv: string;
    installments: number;
    paymentMethod: 'credit_card';
};

type ByBoletoArgs = {
    cpf: string;
    paymentMethod: 'boleto';
};

export type PaymentArgs = ByBoletoArgs | ByCardArgs | ByPixArgs;

export type PaymentMethod = PaymentArgs['paymentMethod'];

export const PixSanitizationMap: Record<PixKeyType, (key: string) => string> = {
    cpf: cpf => formatters.removeNonNumeric(cpf).trim(),
    cnpj: cnpj => formatters.removeNonNumeric(cnpj).trim(),
    phone: phone => '+55' + formatters.removeNonNumeric(phone).trim(),
    email: x => x.trim(),
    uuid: x => x.trim(),
};

export const PixForInputMap: Record<PixKeyType, (key: string) => string> = {
    cpf: _.identity,
    cnpj: _.identity,
    phone: phone => phone.replace(/^\+55/, ''),
    email: _.identity,
    uuid: _.identity,
};

export const getCardRequestArgs = (
    args: PaymentArgs
): Record<string, unknown> =>
    args.paymentMethod === 'credit_card'
        ? {
              card_id: args.cardId,
              cvv: args.cvv,
              installments: args.installments,
              payment_method: 'credit_card',
          }
        : {};

export const getBoletoRequestArgs = (
    args: PaymentArgs
): Record<string, unknown> =>
    args.paymentMethod === 'boleto' ? { cpf: args.cpf } : {};

export type CheckoutBaseInfo = {
    currentBalance: number;
    price: number;
    discount?: number;
};

export type CheckoutDerivedInfo = {
    isFree: boolean;
    hasBalance: boolean;
    actualPrice: number;
};

export const getCheckoutInfo = ({
    price,
    currentBalance,
    discount = 0,
}: CheckoutBaseInfo): CheckoutDerivedInfo => {
    const actualPrice = price - discount < 0 ? 0 : price - discount;
    const isFree = actualPrice === 0;
    const hasBalance = currentBalance - actualPrice >= 0;
    return {
        actualPrice,
        isFree,
        hasBalance,
    };
};
